import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable import/no-cycle */
import Cut from './Cut';
import Tabs from './Tabs';
/* eslint-enable import/no-cycle */

import Audio from './Audio';
import Entity from './Entity';
import Gallery from './Gallery';
import Group from './Group';
import Header from './Header';
import Html from './Html';
import OrderedList from './OrderedList';
import Quote from './Quote';
import Text from './Text';

const Block = ({ type, ...props }) => {
	let block = null;

	switch (type) {
		case 'audio':
			block = <Audio {...props} />;
			break;
		case 'cut':
			block = <Cut {...props} />;
			break;
		case 'gallery':
			block = <Gallery {...props} />;
			break;
		case 'group':
			block = !_(props.items).isEmpty() ? <Group items={props.items} /> : null;
			break;
		case 'header':
			block = <Header {...props} />;
			break;
		case 'html':
			block = <Html {...props} />;
			break;
		case 'line':
			block = <hr />;
			break;
		case 'movie':
			block = <Entity type={type} entity={props[type]} />;
			break;
		case 'orderedList':
			block = <OrderedList list={props} />;
			break;
		case 'quote':
			block = <Quote {...props} />;
			break;
		case 'text':
			block = <Text {...props} />;
			break;
		case 'tabs':
			block = <Tabs {...props} />;
			break;
		// case 'split':
		// 	block = <br />;
		// 	break;
		default:
			block = null;
	}

	return block;
};

Block.propTypes = {
	type: PropTypes.oneOf([
		'audio',
		'cut',
		'gallery',
		'group',
		'header',
		'html',
		'line',
		'movie',
		'orderedList',
		'quote',
		'split',
		'tabs',
		'text'
	])
};

export default Block;
